module.exports = __webpack_public_path__ + "img/ctrl-magic-stub-+i.0d9f2c40.svg";